<template>
  <button
    type="button"
    class="inline-flex items-center w-full px-3 py-2 font-semibold text-lg rounded-lg 
              border-b-2 border-skin-b-list-bord
              focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base"
    :class="{
              'text-green-800 bg-green-50 hover:text-red-800 hover:bg-red-100' : hovercolor=='red',
              'text-skin-b-list-base bg-skin-b-list-head hover:text-green-800 hover:bg-green-100' : hovercolor=='green',
    }">
    <slot></slot>
  </button>
</template>
 <script>
 export default {
   props: {
     hovercolor: {
       type: String,
       default: ''
     }
   }
 };
 </script>